<template>
    <div>
        <form class="filter-group list-filter" style="display: flex; flex-wrap: wrap;">
            <filter-dropdown id="agency" name="Agency" :data="my_filters" :options="dropdowns.agency" multiple></filter-dropdown>
            <filter-dropdown id="account_manager" name="Account Manager" :data="my_filters" :options="dropdowns.account_manager" multiple></filter-dropdown>
            <filter-dropdown id="mc_status" name="MC" :data="my_filters" :options="dropdowns.mc_status" multiple></filter-dropdown>
            <filter-dropdown id="jb_status" name="Job Board" :data="my_filters" :options="dropdowns.jb_status" multiple></filter-dropdown>
            <filter-dropdown id="ja_status" name="JobAdviser" :data="my_filters" :options="dropdowns.ja_status" multiple></filter-dropdown>

            <div class="form-group" style="padding-top: 25px">
                <btn cssClass="btn btn-secondary" icon="fas fa-redo-alt" :click="filter">Filter</btn>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: [
        'filters',
        'dropdowns'
    ],
    data() {
        return {
            show_dialogs: {
                filters: false
            },
            my_filters: _.cloneDeep(this.filters),
        };
    },
    watch: {
        filters() {
            this.my_filters = _.cloneDeep(this.filters);
        }
    },
    methods: {
        filter() {
            return new Promise((resolve, reject) => {
                this.$emit('filter', this.my_filters, resolve);
            })
        },
    }
}
</script>